<script>
/** Type mighty be : default (or null), highlight, overlay**/
export default {
  props: {
    icon: String,
    label: String,
    selected: Boolean,
    select: Object,
    disabled: Boolean,
  },
  data: function () {
    return {};
  },
  methods: {},
};
</script>

<template>
  <div class="f-mini-tab" v-bind:class="{
      'f-mini-tab-selected': selected,
      disabled: disabled,
    }" :disabled="disabled">
    <div class="f-mini-tab-wrapper" @click="!disabled && $emit('select')">
      <template v-if="$slots.default">
        <slot></slot>
      </template>
      <template v-else>
        <f-icon class="f-mini-tab-icon" v-if="icon" :icon="icon"></f-icon>
        <span class="f-mini-tab-label" v-if="label">{{ $vt(label) }}</span>
      </template>
      <div class="f-action" v-if="$slots.action">
        <slot name="action"></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.f-mini-tab {
  padding: 8px 8px 10px 8px;

  .f-action {
    display: flex;
    margin-left: 4px;
  }

  &.disabled {
    .f-mini-tab-wrapper {
      color: #b1b1b1;

      &:hover,
      &:active {
        background-color: inherit;
      }
    }
  }

  .f-mini-tab-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 48px;
    padding: 0 11px;
    border-radius: 6px;
    cursor: pointer;

    &:hover {
      background-color: rgba(24, 144, 211, 0.1);
    }

    &:active {
      background-color: rgba(24, 144, 211, 0.25);
    }
  }

  .f-mini-tab-icon {
    padding-right: 7px;
    font-size: 18px;
    color: rgba(92, 186, 182, 1);
  }

  .f-mini-tab-label {
    font-size: 14px;
    font-weight: 700;
    font-family: Lato;
  }

  &.f-mini-tab-selected {
    border-bottom: solid 2px #1890d3;
  }
}
.dark-mode {
  .f-mini-tab {
    color: var(--white-a75);
    &.disabled {
      .f-mini-tab-wrapper {
        &:hover,
        &:active {
          background-color: inherit;
        }
      }
    }

    .f-mini-tab-wrapper {
      &:hover {
        background-color: rgba(24, 144, 211, 0.1);
      }

      &:active {
        background-color: rgba(24, 144, 211, 0.25);
      }
    }

    .f-mini-tab-icon {
      color: var(--primary);
    }

    .f-mini-tab-label {
      &.f-mini-tab-selected {
        border-bottom: solid 2px var(--navigation)
      }
    }
  }
}
</style>